import { Platform, StyleSheet } from 'react-native';
import { Colors } from '../../themes/colors';
import { tokens } from '../crop-circle/tokens';

export const preferencesStyles = StyleSheet.create({
  contentContainer: {
    paddingTop: tokens.spacing.lg,
    gap: tokens.spacing['2xl'],
    marginBottom: tokens.spacing.lg,
    ...Platform.select({
      web: {
        paddingTop: 0,
      },
    }),
  },
  heading: {
    ...tokens.typography.body.mediumEmphasised,
    color: tokens.colors.neutral[800],
    marginBottom: tokens.spacing.md,
  },
  // Section title shared by the Crop Circle notification screens, matching the
  // activity filter page (filter/filterContent.tsx `sectionTitle`) so all the
  // settings/filter section headers read consistently.
  sectionTitle: {
    ...tokens.typography.label.largeEmphasised,
    fontWeight: tokens.typography.label.largeEmphasised.fontWeight,
    color: tokens.colors.neutral[600],
    marginBottom: tokens.spacing.md,
    letterSpacing: 0.5,
    textTransform: 'uppercase' as const,
  },
  checkbox: {
    flexShrink: 1,
    maxWidth: '100%',
    paddingHorizontal: tokens.spacing.lg,
  },
  label: {
    textAlign: 'left',
    ...tokens.typography.body.medium,
    paddingLeft: tokens.spacing.sm,
  },
  contentFieldForm: {
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: Colors.white,
    borderRadius: 12,
    flexShrink: 1,
    ...Platform.select({
      web: {
        borderRadius: 8,
      },
    }),
  },
  contentFieldFormCropCircle: {
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: tokens.colors.brand.white,
    borderRadius: tokens.borderRadius.xl,
    flexShrink: 1,
    ...Platform.select({
      web: {
        borderRadius: tokens.borderRadius.lg,
      },
    }),
  },
  severityIcon: {
    width: 24,
    height: 24,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkboxPressable: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  checkboxPressableItem: {
    height: 48,
    paddingLeft: 0,
    paddingRight: 0,
    transform: [{ translateX: 6 }],
  },
  checkboxPressableIconLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  divider: {
    height: 0.5,
    margin: 'auto',
    borderBottomColor: Colors.graySpacer,
    width: '100%',
    ...Platform.select({
      web: {
        width: 400,
      },
    }),
  },
});
